<template>
  <section class="selected-category">
    <div class="selected-category__content">
      <h1>{{ getTranslations.home_selected_theme_round }} {{ currentRoundNumber }}</h1>
      <div class="selected-category__content__icon">
        <img :src="themeIconURL" alt="">
        <span class="selected-category__content__icon__name">{{ themeMultilanguageText }}</span>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'selectedThemeFreePlay',
  data() {
    return {
      themeIconURL: '',
      themeMultilanguageText: '',
    };
  },
  created() {
    this.themeIconURL = this.homePlayerCurrentSelectedTheme.iconUrl;
    this.themeMultilanguageText = this.homePlayerCurrentSelectedTheme.displayMultilanguageText;
  },
  mounted() {
    this.goToFreeTrialGamePage();
  },
  methods: {
    goToFreeTrialGamePage() {
      this.normalTransition = true;
      setTimeout(() => {
        this.$router.replace('/trial/game');
      }, 2500);
    },
  },
  computed: {
    ...mapState('game', [
      'currentRoundNumber',
      'homePlayerCurrentSelectedTheme',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/SelectedThemeFreePlay.vue